import React, { useState } from 'react';

function KTXacNhanPhieu() {
  const [ngayNhap, setNgayNhap] = useState(() => {
    const today = new Date();
    return today.toISOString().slice(0, 10);
  });
  const [data, setData] = useState([]);
  const [fetching, setFetching] = useState(false);
  const [fetchError, setFetchError] = useState('');
  const [expanded, setExpanded] = useState({});

  const fetchConfirmedList = async () => {
    setFetching(true);
    setFetchError('');
    setData([]);
    try {
      const url = `https://doticom.vn:3000/api/sale-nhap-hang-confirmed-list?NgayNhap=${ngayNhap}`;
      const token = localStorage.getItem('token');
      const res = await fetch(url, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (!res.ok) {
        setFetchError('Không lấy được dữ liệu');
        setFetching(false);
        return;
      }
      const result = await res.json();
      setData(result);
    } catch (err) {
      setFetchError('Lỗi kết nối server');
    }
    setFetching(false);
  };

  return (
    <div className="container mt-4" style={{maxWidth: 900}}>
      <h3 className="mb-3">Danh sách phiếu đã xác nhận</h3>
      <form className="row g-3 align-items-end mb-3" onSubmit={e => { e.preventDefault(); fetchConfirmedList(); }}>
        <div className="col-auto">
          <label className="form-label">Ngày nhập</label>
          <input
            className="form-control"
            type="date"
            value={ngayNhap}
            onChange={e => setNgayNhap(e.target.value)}
            required
            style={{width: 160}}
          />
        </div>
        <div className="col-auto">
          <button className="btn btn-success" type="submit" disabled={fetching}>
            {fetching ? 'Đang tải...' : 'Xem danh sách'}
          </button>
        </div>
      </form>
      {fetchError && <div className="alert alert-danger py-2 mb-3">{fetchError}</div>}
      {data && data.length > 0 ? (
        <div className="table-responsive">
          <table className="table table-bordered table-hover align-middle">
            <thead className="table-light">
              <tr>
                <th></th>
                <th>Mã phiếu</th>
                <th>Số phiếu</th>
                <th>Mã cửa hàng</th>
                <th>Ngày nhập</th>
                <th>Người xác nhận</th>
                <th>Ghi chú</th>
              </tr>
            </thead>
            <tbody>
              {data.map(row => (
                <React.Fragment key={row.MaPN}>
                  <tr>
                    <td style={{width: 40}}>
                      <button
                        className="btn btn-link btn-sm"
                        type="button"
                        onClick={() => setExpanded(prev => ({...prev, [row.MaPN]: !prev[row.MaPN]}))}
                        aria-label="Xem chi tiết"
                      >
                        {expanded[row.MaPN] ? '−' : '+'}
                      </button>
                    </td>
                    <td>{row.MaPN}</td>
                    <td>{row.SoPN}</td>
                    <td>{row.MaCH}</td>
                    <td>{row.NgayNhap ? new Date(row.NgayNhap).toLocaleDateString() : ''}</td>
                    <td>{row.TenUser}</td>
                    <td>{row.GhiChu}</td>
                  </tr>
                  {expanded[row.MaPN] && (
                    <tr>
                      <td colSpan={7}>
                        <div className="table-responsive">
                          <table className="table table-sm table-bordered mb-0">
                            <thead className="table-light">
                              <tr>
                                <th>Mã SP</th>
                                <th>Tên SP</th>
                                <th>Số lượng</th>
                                <th>SL thực nhận</th>
                                <th>Giá mua</th>
                                <th>Thành tiền</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {/* Đưa các hàng có SLThucNhan khác SoLuong lên trên */}
                              {[...(row.chiTiet || [])]
                                .sort((a, b) => {
                                  const diffA = String(a.SLThucNhan) !== String(a.SoLuong) ? -1 : 1;
                                  const diffB = String(b.SLThucNhan) !== String(b.SoLuong) ? -1 : 1;
                                  return diffA - diffB;
                                })
                                .map(ct => {
                                  const isDiff = String(ct.SLThucNhan) !== String(ct.SoLuong);
                                  return (
                                    <tr key={ct.IDNhapCT} className={isDiff ? 'table-warning' : ''}>
                                      <td>{ct.MaSP}</td>
                                      <td>{ct.TenSP}</td>
                                      <td>{ct.SoLuong}</td>
                                      <td>{ct.SLThucNhan}</td>
                                      <td>{ct.GiaMua}</td>
                                      <td>{ct.ThanhTien}</td>
                                      <td>
                                        {isDiff && (
                                          <button className="btn btn-outline-primary btn-sm">
                                            Action
                                          </button>
                                        )}
                                      </td>
                                    </tr>
                                  );
                                })}
                            </tbody>
                          </table>
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      ) : fetching ? null : (
        <div className="text-muted">Không có dữ liệu.</div>
      )}
    </div>
  );
}

export default KTXacNhanPhieu;
